<template>
  <div class="editorContainer">
    <div id="editor"></div>
  </div>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import Table from "editorjs-table";
import Underline from "@editorjs/underline";
import RawTool from "@editorjs/raw";
import {
  ProTipPlugin,
  ImagePlugin,
  WarningPlugin,
  QuotePlugin,
  FeaturedPostPlugin,
  FeaturedProductPlugin,
  LinkInlineTool,
} from "../plugins";
import { countW, countC } from "@/utils";

export default {
  name: "Editor",
  props: ["_post"],
  data() {
    return {
      saveLoading: false,
      editor: null,
      output: null,
    };
  },
  emits: ["change", "countChange"],

  async mounted() {
    let data = this._post.jsonBlocks;

    // initialize editor
    if (this.editor) return;
    this.editor = new EditorJS({
      holder: "editor",
      data,
      placeholder: "Start writing a blog post!",
      tools: {
        underline: Underline,
        header: {
          class: Header,
          config: {
            levels: [2, 3, 4],
            defaultLevel: 2,
            inlineToolbar: true,
          },
          shortcut: "CTRL+ALT+2",
        },
        table: {
          class: Table,
          inlineToolbar: true,
        },
        list: { class: List, inlineToolbar: true },
        image: { class: ImagePlugin, inlineToolbar: true },
        proTip: { class: ProTipPlugin, inlineToolbar: true },
        warning: { class: WarningPlugin, inlineToolbar: true },
        quote: { class: QuotePlugin, inlineToolbar: true },
        link: LinkInlineTool,
        featuredPost: { class: FeaturedPostPlugin, inlineToolbar: true },
        featuredProduct: { class: FeaturedProductPlugin, inlineToolbar: true },
        code: RawTool,
      },
      inlineToolbar: ["bold", "italic", "underline", "link"],
      onChange: this.save,
      onReady: () => {
        // count change
        ["mouseup", "keyup"].forEach((event) => {
          document.getElementById("editor").addEventListener(event, () => {
            let text;
            let selection = document.getSelection().toString();
            if (selection && selection.length) text = selection;

            if (text && text.length)
              this.$emit("countChange", {
                chars: countC(text),
                words: countW(text),
              });
            else this.$emit("countChange", null);
          });
        });

        // hide count on mouse out + leave
        ["mouseleave"].forEach((event) => {
          document.getElementById("editor").addEventListener(event, () => {
            this.$emit("countChange", null);
          });
        });

        this.save();
      },
      logLevel: "ERROR",
    });
  },

  methods: {
    save() {
      this.saveLoading = true;
      this.editor
        .save()
        .then((outputData) => {
          this.output = outputData;
          this.$emit("change", {
            jsonBlocks: outputData,
          });
          this.saveLoading = false;
        })
        .catch((error) => {
          console.log("Saving failed: ", error);
          this.saveLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
#editor {
  background-color: white;
  border-radius: 0.25rem;
  padding: 2rem 0;
  margin-bottom: 2rem;
  box-shadow: 2px 2px 25px 10px whitesmoke;

  font-family: "Source Sans Pro", sans-serif;
  font-size: 1rem;

  .pluginIcon {
    color: black;
  }
}

.ce-block__content,
.ce-toolbar__content {
  width: 100%;
  max-width: 768px;
}
</style>
